



























import { defineComponent, ref, watch } from '@nuxtjs/composition-api';
import useMyLocation from '@shared/composables/useMyLocation';
import useMyStore from '@shared/composables/useMyStore';
import useNearbyStores from '@shared/composables/useNearbyStores';
import useResponsive from '@shared/composables/useResponsive';
import useUiState from '@shared/composables/useUiState';
import { NearbyStoreParams } from '@shared/types/locations';
import { StoreDetails } from '@shared/types/stores';
import { BaseSidebar } from '@shared/ui';
import { Logger } from '@vue-storefront/core';

import StoreLocatorHeader from '~/components/Stores/StoreLocatorHeader.vue';
import StoresList from '~/components/Stores/StoresList.vue';
import StoresPicker from '~/components/Stores/StoresPicker.vue';

import NearestStoreSearch from './NearestStoreSearch.vue';

export default defineComponent({
  name: 'StoresSidebar',
  components: { StoresList, StoreLocatorHeader, NearestStoreSearch, BaseSidebar, StoresPicker },
  setup() {
    const { isStoresSidebarOpen, toggleStoresSidebar } = useUiState();
    const { saveLocation } = useMyLocation();
    const { isMobile } = useResponsive();
    const stores = ref<StoreDetails[] | null>(null);
    const { myStore } = useMyStore();
    const showStoresPicker = ref(false);
    const nearbyStoresLoading = ref(false);
    const { getNearbyStores } = useNearbyStores(`stores-sidebar`);

    const reset = () => {
      showStoresPicker.value = false;
      nearbyStoresLoading.value = false;
      stores.value = null;
    };

    const searchNearbyStores = async ({ lat, lng, placeId }: NearbyStoreParams) => {
      setShowStoresPicker(false);
      nearbyStoresLoading.value = true;
      stores.value = null;
      try {
        stores.value = await getNearbyStores({ lat, lng, placeId });
        if (lat && lng) saveLocation({ lat, lng });
      } catch (err) {
        Logger.error('Failed to fetch nearby stores', err);
      } finally {
        nearbyStoresLoading.value = false;
      }
    };

    watch(
      myStore,
      (store, prevStore) => {
        if (isMobile.value || (!prevStore && !store) || prevStore?.name === store?.name) return;
        stores.value = null;
        toggleStoresSidebar(false);
      },
      { immediate: false },
    );

    watch(isStoresSidebarOpen, () => {
      if (!isStoresSidebarOpen.value) {
        reset();
      }
    });

    const setShowStoresPicker = (val: boolean) => {
      showStoresPicker.value = val;
    };

    return {
      stores,
      isStoresSidebarOpen,
      isMobile,
      toggleStoresSidebar,
      searchNearbyStores,
      showStoresPicker,
      setShowStoresPicker,
      nearbyStoresLoading,
    };
  },
});
